import React, { useState, Context, ReactElement, Component } from "react";

export interface nodes_type {
  kind: string;
  items: nodes_type_item[];
}

export interface nodes_type_item {
  kind: string;
  apiVersion: string;
  metadata: {
    name: string;
    uid: string;
    selfLink: string;
    resourceVersion: string;
    creationTimestamp: string;
    labels: any;
    role: string;
    annotations: object;
    pod: string;
    limitCPU: string;
    limitMemory: string;
    requestCPU: string;
    requestMemory: string;
    totalCPU: string;
    totalMemory: string;
    totalRootfs: string;
    totalPod: string;
    totalDisk: string;
    totalGPU: string;
    usedCPU: string;
    usedMemory: string;
    usedRootfs: string;
    usedPod: string;
    usedDisk: string;
    usedGPU: string;
  };
  spec: object;
  status: {
    capacity: {
      cpu: string;
      memory: string;
      pods: string;
    };
    allocatable: {
      cpu: string;
      memory: string;
      pods: string;
    };
    conditions: node_status_conditions_item[];
    addresses: node_status_address_item[];
    daemonEndpoints: {
      kubeletEndpoint: object;
    };
    nodeInfo: {
      machineID: string;
      systemUUID: string;
      bootID: string;
      kernelVersion: string;
      osImage: string;
      containerRuntimeVersion: string;
      kubeletVersion: string;
      kubeProxyVersion: string;
      operatingSystem: string;
      architecture: string;
    };
    images: node_status_images_item[];
    volumesInUse: string[];
    volumesAttached: node_status_volumesAttached_item[];
  }
}

export interface node_status_conditions_item {
  type: string;
  status: string;
  lastHeartbeatTime: string;
  lastTransitionTime: string;
  reason: string;
  message: string;
}

export interface node_status_address_item {
  type: string;
  addresses: string;
}

export interface node_status_images_item {
  names: string[];
  sizeBytes: number;
}

export interface node_status_volumesAttached_item {
  name: string;
  devicePath: string;
}

const NodeContext: Context<[nodes_type['items'], React.Dispatch<React.SetStateAction<nodes_type['items']>>]> = React.createContext<[nodes_type['items'], React.Dispatch<React.SetStateAction<nodes_type['items']>>]>([[] as unknown as nodes_type['items'], (_value: any) => { }]);

const NodesProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [nodes, set_nodes]: [nodes_type['items'], React.Dispatch<React.SetStateAction<nodes_type['items']>>] = useState([] as unknown as nodes_type['items']);
  return (
    <NodeContext.Provider value={[nodes, set_nodes]}>
      {props.children}
    </NodeContext.Provider>
  )
}

export { NodeContext, NodesProvider };
